'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal(props) {
    (0, _classCallCheck3.default)(this, Modal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props));

    _this.onEscapeBound = _this.onEscape.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.classList.add('no-scroll');
      document.addEventListener('keyup', this.onEscapeBound);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.classList.remove('no-scroll');
      document.removeEventListener('keyup', this.onEscapeBound);
    }
  }, {
    key: 'onEscape',
    value: function onEscape(e) {
      // ESC key
      if (e.keyCode === 27) {
        this.props.closeCallback();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        height: this.props.height + 'px',
        width: this.props.width + 'px',
        marginTop: '-' + this.props.height / 2 + 'px',
        marginLeft: '-' + this.props.width / 2 + 'px',
        background: '#fff'
      };

      return _react2.default.createElement(
        'div',
        { className: 'oe-modal' },
        _react2.default.createElement('div', { className: 'modal-overlay', onClick: this.props.closeCallback }),
        _react2.default.createElement(
          'div',
          { className: 'modal-contents', style: style },
          this.props.children
        )
      );
    }
  }]);
  return Modal;
}(_react.Component);

exports.default = Modal;


Modal.propTypes = {
  height: _propTypes2.default.number,
  width: _propTypes2.default.number,
  children: _propTypes2.default.object,
  closeCallback: _propTypes2.default.func
};